import { render } from "./edit_language_component.vue?vue&type=template&id=aa9a52a6&scoped=true"
import script from "./edit_language_component.vue?vue&type=script&lang=js"
export * from "./edit_language_component.vue?vue&type=script&lang=js"

import "./edit_language_component.vue?vue&type=style&index=0&id=aa9a52a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9a52a6"]])

export default __exports__